import 'angular:locale/data:fr';
import 'angular:locale/data:pl';
import 'angular:locale/data:ca';
import 'angular:locale/data:en';
import 'angular:locale/data:es';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
